import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import {  Accordion, Card, Container as ContainerBody, Row, Col } from 'react-bootstrap';
import EditIcon from "@material-ui/icons/Edit";

import {
  Container,
  CardOrder,
  MainContainer
} from '~/components/layout/Logistic/styles';

import {
  ButtonDivision,
  CardBody,
  CardHeader,
  CardInput,
  CardInputItem,
  CenterHeaderLabel,
  CenterHeaderQuantity,
  CenterItemQuantity,
  CloseIconStyled as IconStyled,
  ColAppliedHeaderQuantity,
  ColAproveHeaderQuantity,
  InputApply,
  LabelProduct,
  LeftHeaderQuantity,
  LeftItemQuantity,
  LefItemQuantity,
  LimitText,
  LoadingIcon,
  Product,
  RightHeaderQuantity,
  RightItemQuantity,
  SubLeftItemQuantity,
  SubLeftItemQuantityMobile,
  TextQuantity,
  Title,
  TitlePage as IconsTop,
  ValueQuantity,
} from './styles';
import '~/components/styles/Global.css';
import close from '~/assets/images/close.png';
import IconProduct from '~/components/layout/IconProduct';
import api from '~/services/api';
import Loading from '~/components/layout/Loading';
import OpenChatBot from '~/components/layout/Chatbot';
import Stepper from '~/components/layout/Logistic/StepperLine';
import RedirectToInitial from '~/components/layout/Logistic/RedirectToInitial';
import RedirectToPortal from '~/components/layout/Logistic/RedirectToPortal';
import back from '~/assets/images/back.svg';
import { InfoButton } from '~/components/layout/Buttons';
import { verifyRoles } from '~/utils/functions/verifyRoles';
import { formatCurrency } from '~/utils/utils';


export default function FinancialComposition() {
  const [loadingPage, setLoadingPage] = useState(true);
  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [financialComposition, setFinancialComposition] = useState(null);
  const [inputValues, setInputValues] = useState({});
  const [accordionOpen, setAccordionOpen] = useState([]);
  const [loadReplacement, setLoadReplacement] = useState(false);
  const [modalRedirect, setModalRedirect] = useState(false);
  const [modalCancel, setModalCancel] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();

  const roles = useSelector(state => state.rolesReducer.roles);
  const logisticReducer = useSelector(state => state.logisticReducer);

  useEffect(() => {
    if (logisticReducer?.replacement?.applied && loadReplacement) {
      setInputValues(logisticReducer.replacement.data);
    }
  }, [loadReplacement]);

  useEffect(() => {
    console.log("Logistic reducer replacement --> ", logisticReducer);
    getFinancialReplacement();
  }, []);

  useEffect(() => {
    console.log("financialComposition", financialComposition)
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 771);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() =>{
    if(financialComposition) {
      dispatch({ type: "SET_INITIAL_ORDER_VALUE", inicialOrderValue: financialComposition && parseFloat(financialComposition.orderSubtotalReplacements)});
    }
  },[financialComposition])

  const mapperType = {
    vouchers: 'Vale Gás',
    shifts: 'Trocas Aprovadas',
    sponsoreds: 'Subsidiados'
  }

  const concatProductsIds = (payload) => {
    const { products } = payload;
    if (!products || !Array.isArray(products) || products.length === 0) {
      return '';
    }

    const productIds = '&products=' + products.map(product => product.productId).join(',');
    return productIds;
  }


  async function getFinancialReplacement () {

    try {
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem('access_token'),
      };
      const parameters = {
        method: 'GET',
        headers: header,
      };
      const storeId = localStorage.getItem('storeId');
      const url = `/sales/order/v2/orders-ga/${logisticReducer.orderDraft.response.orderId}/replacements?accountId=${storeId}${concatProductsIds(logisticReducer.orderDraft.response)}`;

      const res = await api.get(url, parameters);

      const replacementOptions = res.data;
      const resultReplacement = createReplacementPayload(logisticReducer.priceList, replacementOptions);
      setFinancialComposition(resultReplacement);

      if (hasNonZeroQuantityItem(replacementOptions)) {
          setLoadReplacement(true);
          setLoadingPage(false);
      } else {
          valuations();
      }
    } catch (err) {
      console.log('err => ', err);
      toast.error('Ocorreu um problema de conexão, pedimos a gentileza de tentar novamente em alguns instantes.');
      setLoadingPage(false);
      handleHome()
    }

  };

  function hasNonZeroQuantityItem(data) {
    for (const key in data) {
      if (key !== "sponsoreds") {
        const items = data[key];
        for (const item of items) {
          if (item.quantity > 0) {
            return true;
          }
        }
      }
    }
    return false;
  }

  function createReplacementPayload( priceResponse, replacementOptions) {
    try {
      const orderProducts = logisticReducer.orderDraft.payload.products || [];

      let orderSubtotalReplacements = 0;
      const replacementList = [];

      const replacementOptionsArray = Object.entries(replacementOptions).map(([type, options]) => {
        return options.map((option) => ({ ...option, type }));
      }).flat();

      for (const product of orderProducts) {
        const productId = parseInt(product.productId);
        const quantity = product.quantity;

        let productPriceInfo;

        if (Array.isArray(priceResponse.Ordem.listaPreco)) {
          productPriceInfo = priceResponse.Ordem.listaPreco.find((option) => parseInt(option.listaPrecoItem.itens.item.id) === productId);
        } else if (typeof priceResponse.Ordem.listaPreco === 'object') {
          productPriceInfo = parseInt(priceResponse.Ordem.listaPreco.listaPrecoItem.itens.item.id) === productId
            ? priceResponse.Ordem.listaPreco
            : null;
        }
        console.log("productPriceInfo", productPriceInfo)
        const productPrice = productPriceInfo ? productPriceInfo.listaPrecoItem.itens.precoUnitario : 0;
        const totalPrice = productPrice * quantity;

        orderSubtotalReplacements += totalPrice;
        const replacementOption = replacementOptionsArray.filter((option) => parseInt(option.productId) === productId && option.quantity > 0);

        if (replacementOption.length > 0) {
            const subsidizedEmpties = replacementOption.reduce((acc, item) => {
            if (!acc[item.productId]) {
              acc[item.productId] = 0;
            }
            acc[item.productId] += item.type !== 'sponsoreds' ? item.quantity : 0;
            return acc;
          }, {});

          const productName = logisticReducer.products.find((item) => parseInt(item.id) === productId).name;

          replacementList.push({
            productId: productId,
            nameProduct: productName,
            quantity: quantity,
            totalPrice: totalPrice,
            subsidizedEmpties: subsidizedEmpties[productId.toString()],
            itemsSubsidized: replacementOption,
          });
        }
      }
      const payload = {
        orderSubtotalReplacements: orderSubtotalReplacements,
        replacement: replacementList,
      };
      return payload;
    } catch (error) {
      console.log("Error in mount payload replacement", error);
      return {}
    }
  }

  function handleInputChange (event, maxValue, productId, type) {
    const { value } = event.target;
    const valueParsed = parseInt(value ? value : 0);

    if (typeof valueParsed === 'number' && valueParsed >= 0 && valueParsed <= maxValue) {
      setInputValues(prevState => ({
        ...prevState,
        [productId]: {
          ...prevState[productId],
          [type]: valueParsed,
        }
      }));
    }
  };

  function sumTotalAppliedForProductId(data, productIdToSum) {
    let totalValue = 0;

    if (data[productIdToSum]) {
      const product = data[productIdToSum];
      for (const key in product) {
        if (!key.includes("Changed")) {
          totalValue += product[key];
        }
      }
    }

    return totalValue;
  }

  function getPayloadValuation() {
    try {
      const payload = {
        accountId: localStorage.getItem('storeId'),
        products: []
      };

      for (const product of logisticReducer.orderDraft.response.products) {
        const productId = parseInt(product.productId);
        const quantity = logisticReducer.orderDraft.payload.products.find(p => parseInt(p.productId) === productId).quantity || 0;

        const paymentConditionId = Array.isArray(logisticReducer.paymentCondition.CondicaoPagamento.Ordem.cliente.condicaoPagamento)
          ? (logisticReducer.paymentCondition.CondicaoPagamento.Ordem.cliente.condicaoPagamento.find(item => item.itens.id === productId).id || "")
          : (logisticReducer.paymentCondition.CondicaoPagamento.Ordem.cliente.condicaoPagamento?.itens.id === productId
              ? logisticReducer.paymentCondition.CondicaoPagamento.Ordem.cliente.condicaoPagamento.id || ""
              : "");

        const consultantId = Array.isArray(logisticReducer.salesConsultant.ConsultorVendas.Ordem.consultor)
          ? (logisticReducer.salesConsultant.ConsultorVendas.Ordem.consultor.find(item => item.itens.id === productId).id || "")
          : (logisticReducer.salesConsultant.ConsultorVendas.Ordem.consultor?.itens.id === productId
              ? logisticReducer.salesConsultant.ConsultorVendas.Ordem.consultor.id || ""
              : "");

        let shippingTaxId = 0;
        if(logisticReducer.taxDelivery) {
           shippingTaxId = Array.isArray(logisticReducer.taxDelivery.TaxaEntrega.Ordem.linhaOrdem.linhas)
          ? (logisticReducer.taxDelivery.TaxaEntrega.Ordem.linhaOrdem.linhas.find(item => item.item.id === productId)?.precoTotal || "0")
          : (logisticReducer.taxDelivery.TaxaEntrega.Ordem.linhaOrdem.linhas?.item.id === productId
              ? logisticReducer.taxDelivery.TaxaEntrega.Ordem.linhaOrdem.linhas?.precoTotal || "0"
              : "0");
         }

        const priceInfo = Array.isArray(logisticReducer.priceList.Ordem.listaPreco)
          ? logisticReducer.priceList.Ordem.listaPreco.find(item => parseInt(item.listaPrecoItem.itens.item.id) === productId)
          : (logisticReducer.priceList.Ordem.listaPreco?.listaPrecoItem.itens.item.id === productId
              ? logisticReducer.priceList.Ordem?.listaPreco
              : null);

        const unitPrice = priceInfo ? priceInfo.listaPrecoItem.itens.precoUnitario.toString() : 0;
        const listName = priceInfo ? `${priceInfo.nome} - ${priceInfo.descricao}` : "";
        const listId = priceInfo ? priceInfo.id.toString() : "";

        payload.products.push({
          id: productId,
          quantity: quantity.toString(),
          externalConsultantId: consultantId.toString(),
          paymentConditionId: paymentConditionId.toString(),
          price: {
            listId: listId,
            unitPrice: unitPrice,
            listName: listName
          },
          shippingTax: shippingTaxId,
          shiftReplacementQuantity: inputValues[productId]?.shifts ? inputValues[productId].shifts.toString() : "0",
          sponsoredReplacementQuantity: logisticReducer.subsidized.applied ? getValueItemSubsidized({ productId: productId }, logisticReducer.subsidized.data).toString() : '0',
          voucherReplacementQuantity: inputValues[productId]?.vouchers ? inputValues[productId].vouchers.toString() : "0",
        });
      }
      return payload;
    } catch (error) {
      console.log("Error in mount payload valuation", error);
      return {}
    }
  }

  async function valuations(applied= false) {
    setLoadingConfirm(true);
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };

    const body = getPayloadValuation();

    await api
      .post(`/sales/order/v2/orders-ga/${logisticReducer.orderDraft.response.orderId}/valuations`, body, parameters)
      .then(res => {
        handleNextStep(res.data, applied);
      })
      .catch(err => {
        setLoadingConfirm(false);
        const erro = err.response;
        if (erro.status) {
          const message = err.response.data.message;
          if (message) {
            toast.error(message);
          } else {
            toast.error('Ocorreu um problema de conexão, pedimos a gentileza de tentar novamente em alguns instantes.');
            setLoadingPage(false);
            handleHome()
          }
          setLoadingPage(false);
        }
      });
  };

  function transformValuationResponse(valuationResponse, inputValue) {
    const transformedInputValue = {};
    let changedFieldsCreated = false;

    for (const productId in inputValue) {
      if (inputValue.hasOwnProperty(productId)) {
        transformedInputValue[productId] = {};

        if (valuationResponse.products) {
          const productInfo = valuationResponse.products.find((product) => product.id === productId);

          if (productInfo) {
            if (inputValue[productId].vouchers !== undefined) {
              const vouchersValue = productInfo.voucherReplacementQuantity;
              transformedInputValue[productId].vouchers = vouchersValue;

              if (inputValue[productId].vouchers !== vouchersValue) {
                transformedInputValue[productId].vouchersChanged = true;
                changedFieldsCreated = true;
              } else {
                transformedInputValue[productId].vouchersChanged = false;
              }
            }

            if (inputValue[productId].shifts !== undefined) {
              const shiftsValue = productInfo.shiftReplacementQuantity;
              transformedInputValue[productId].shifts = shiftsValue;

              if (inputValue[productId].shifts !== shiftsValue) {
                transformedInputValue[productId].shiftsChanged = true;
                changedFieldsCreated = true;
              } else {
                transformedInputValue[productId].shiftsChanged = false;
              }
            }

            if (inputValue[productId].value !== undefined) {
              const sponsoredsValue = productInfo.sponsoredReplacementQuantity;
              transformedInputValue[productId].sponsoreds = sponsoredsValue;
              transformedInputValue[productId].value = sponsoredsValue;

              if (inputValue[productId].value !== sponsoredsValue) {
                transformedInputValue[productId].sponsoredsChanged = true;
                changedFieldsCreated = true;
              } else {
                transformedInputValue[productId].sponsoredsChanged = false;
              }
            }
          } else {
            transformedInputValue[productId] = inputValue[productId];
            for (const key in inputValue[productId]) {
              if (inputValue[productId].hasOwnProperty(key)) {
                transformedInputValue[productId][`${key}Changed`] = true;
                changedFieldsCreated = true;
              }
            }
          }
        }
      }
    }

    if (changedFieldsCreated && valuationResponse.message) {
      toast.error(`${valuationResponse.message}`);
    }
    return transformedInputValue;
  }

  function handleNextStep(valuationResponse, applied) {

      dispatch({
        type: 'SET_SUBSIDIZED',
        subsidizedData: {
          applied: logisticReducer?.subsidized?.applied ? true : false,
          data: transformValuationResponse(valuationResponse, logisticReducer.subsidized.data)
        }
      });


    const inputKeys = Object.keys(inputValues);

    if (inputValues[inputKeys[0]]?.vouchers > 0 || inputValues[inputKeys[0]]?.shifts > 0 ) {
      toast.success('Reposição realizada com sucesso');
    }

      dispatch({
        type: 'SET_REPLACEMENT',
        replacementData: {
          applied: Object.keys(inputValues).length || applied ? true : false,
          data: transformValuationResponse(valuationResponse, inputValues),
          response: valuationResponse
        }
      });


    setTimeout(() => {
      setLoadingConfirm(false);
      history.push('/composicao-financeira-descontos');
    }, 2000);
  }

  function toggleAccordion() {
    setAccordionOpen(!accordionOpen);
  };

  function handleBack() {
    if (logisticReducer.subsidized.applied) {
      history.push('/vasilhames-subsidiados');
    } else {
      if (logisticReducer.previousPage === '/criar-pedido') {
        setModalRedirect(true)
      } else {
        history.push(logisticReducer.previousPage);
      }
    }
  }

  function handleHome() {
    history.push('/portal');
  }

  function getValueItemSubsidized(item, data) {
    return data[item.productId] ? data[item.productId].value : 0;
  }

  return (
    <Container>
      <IconsTop>
        <IconStyled
          src={back}
          alt="Ícone de voltar"
          onClick={() =>  handleBack()}
        />
        <IconStyled
          src={close}
          alt="Ícone de fechar"
          onClick={() => setModalCancel(true)}
        />
      </IconsTop>
      <RedirectToInitial
        modalRedirect={modalRedirect}
        setModalRedirect={setModalRedirect}
      />
      <RedirectToPortal
        modalRedirect={modalCancel}
        setModalRedirect={setModalCancel}
      />
      {verifyRoles(roles, 'PEDIDO_DE_ABASTECIMENTO') ? (
        <>
          {loadingPage ? (
            <Loading loadingColor={'white'} />
          ) : (
          <>
            <CardOrder>
              <MainContainer>
                <Title>
                  <span>Composição Financeira - Reposições</span>
                </Title>
                <Stepper activeStep={4} steps={7} />
                <>
                  <CardInput>
                    <CardInputItem>
                      <Row className="justify-content-between">
                        <Col className="text-left">
                          <TextQuantity>Subtotal do Pedido</TextQuantity>
                        </Col>
                        <Col className="text-right">
                          <ValueQuantity>{ financialComposition && formatCurrency(financialComposition.orderSubtotalReplacements) }</ValueQuantity>
                        </Col>
                      </Row>
                    </CardInputItem>
                  </CardInput>
                </>
                {financialComposition && financialComposition.replacement.map((item) => (
                  <Accordion style={{ marginTop: 15 }}>
                    <Card.Header style={CardHeader}>
                      <ContainerBody>
                        <Row className="p-0">
                          <Col xs={4} className="px-0 p-0">
                            <Product>
                              <IconProduct
                                productName="p13"
                                styles={{
                                  p2: { margin: "0 .2rem .2rem 0", width: isMobile ? "24%" : "15%" },
                                  p5: { margin: "0 .2rem .2rem 0", width: isMobile ? "24%" : "15%" },
                                  p20: { margin: "0 .2rem .2rem 0", width: isMobile ? "20%" : "10%" },
                                  p45: { margin: "0 .2rem .2rem 0", width: isMobile ? "20%" : "10%" },
                                  p90: { margin: "0 .2rem .2rem 0", width: isMobile ? "20%" : "10%" },
                                  p13: { margin: "0 .2rem .2rem 0", width: isMobile ? "24%" : "15%" }
                                }}
                              />
                              <LabelProduct>
                                <LeftItemQuantity>{item.nameProduct}</LeftItemQuantity>
                                <SubLeftItemQuantity>Vasilhames subsidiados</SubLeftItemQuantity>
                                <SubLeftItemQuantityMobile>
                                  <LimitText>
                                    Subsidiados
                                  </LimitText>
                                </SubLeftItemQuantityMobile>
                              </LabelProduct>
                            </Product>
                          </Col>
                          <Col xs={4} style={{ padding: '0rem' }} className="px-0 p-0">
                            <LabelProduct>
                              <CenterItemQuantity>{`Qtd: ${item.quantity}`}</CenterItemQuantity>
                              <CenterItemQuantity style={{ marginTop: '0rem'}}>{`Qtd: ${logisticReducer.subsidized?.applied ? getValueItemSubsidized(item, logisticReducer.subsidized.data) : 0}`}</CenterItemQuantity>
                            </LabelProduct>
                          </Col>
                          <Col xs={4} className="px-0 p-0">
                            <RightItemQuantity>{formatCurrency(item.totalPrice)}</RightItemQuantity>
                          </Col>
                        </Row>
                      </ContainerBody>
                    </Card.Header>
                    <Card style={{ boxShadow: '0px 2px 4px #00000033' }} >
                      <ContainerBody>
                        <CardBody>
                          <Row style={{ width: '100%' }} className="p-0">
                            <Col xs={4} className="p-0">
                              <LeftHeaderQuantity>Reposições</LeftHeaderQuantity>
                            </Col>
                            <Col xs={4} className="p-0">
                              <ColAproveHeaderQuantity>
                                <CenterHeaderLabel>Disponível</CenterHeaderLabel>
                                <CenterHeaderQuantity>{item.subsidizedEmpties}</CenterHeaderQuantity>
                              </ColAproveHeaderQuantity>
                            </Col>
                            <Col xs={4} className="p-0">
                              <Row className="p-0">
                                <Col xs={9} className="p-0">
                                  <CenterHeaderLabel>Aplicar</CenterHeaderLabel>
                                  <CenterHeaderQuantity>{sumTotalAppliedForProductId(inputValues, item.productId)}</CenterHeaderQuantity>
                                </Col>
                                <Col xs={3} className="p-0" style={{ textAlign: 'center' }}>
                                <Accordion.Toggle eventKey="0" onClick={toggleAccordion} className="custom-accordion-toggle">
                                    <RightHeaderQuantity><EditIcon /></RightHeaderQuantity>
                                  </Accordion.Toggle>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Accordion.Collapse eventKey={"0"} style={{ width: '96%' }}>
                            <Row className="p-0">
                              <Col xs={4} className="p-0">
                                {item.itemsSubsidized.map((subsidizedItem) => (
                                  subsidizedItem.type !== "sponsoreds" && (
                                    <LefItemQuantity style={{ paddingLeft: '0.5rem' }}>
                                      {subsidizedItem?.name ? subsidizedItem.name : mapperType[subsidizedItem.type] ? mapperType[subsidizedItem.type] : subsidizedItem.type }
                                    </LefItemQuantity>
                                  )
                                ))}
                              </Col>
                              <Col xs={4} className="p-0">
                                {item.itemsSubsidized.map((subsidizedItem) => (
                                  subsidizedItem.type !== "sponsoreds" && (
                                    <ColAppliedHeaderQuantity>
                                      <CenterHeaderQuantity style={{ margin: '1rem 0.5rem 0.5rem 0rem' }}>{subsidizedItem.quantity}</CenterHeaderQuantity>
                                    </ColAppliedHeaderQuantity>
                                  )
                                ))}
                              </Col>
                              <Col xs={4} className="p-0">
                                <Row className="p-0">
                                  <Col xs={9} className="p-0">
                                    {item.itemsSubsidized.map((subsidizedItem) => (
                                      subsidizedItem.type !== "sponsoreds" && (
                                        <ColAppliedHeaderQuantity style={{ margin: '0.5rem 0.5rem 0rem 0.3rem' }}>
                                          <InputApply
                                            value={inputValues[subsidizedItem.productId]?.[subsidizedItem.type] || 0}
                                            onChange={(e) => handleInputChange(e, subsidizedItem.quantity, subsidizedItem.productId, subsidizedItem.type)}
                                            min={0}
                                          />
                                        </ColAppliedHeaderQuantity>
                                      )
                                    ))}
                                  </Col>
                                  <Col xs={3} className="p-0">
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            </Accordion.Collapse>
                        </CardBody>
                      </ContainerBody>
                    </Card>
                  </Accordion>
                ))}
                <ButtonDivision onClick={() => valuations(true)} >
                  <InfoButton style={{ margin: "0.5rem 0 1rem 0" }} disabled={loadingConfirm}>
                    {loadingConfirm ? (
                      <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                    ) : (
                      <div> Prosseguir</div>
                    )}
                  </InfoButton>
                </ButtonDivision>
              </MainContainer>
              <OpenChatBot backgroundColor={'#00f3ff'} />
            </CardOrder>
          </>
          )}
        </>
      ) : (
        <Redirect to="/portal" />
      )}
    </Container>
  );
}
